// Enum for numeric ID's above. Stored numerically in database, so don't change values!
export enum ToolTypeId {
  Unknown = 0,
  FlatEndmill = 1,
  RadiusEndmill = 2,
  BallEndmill = 3,
  ChamferMill = 4,
  Drill = 5,
  FaceMill = 6,
  Flycutter = 7,
  CuttingTap = 8,
  FormTap = 9,
  LollipopEndmill = 10,
  KeyseatCutter = 11,
  DovetailCutter = 12,
  Reamer = 13,
  BoringBar = 14,
  CounterBore = 15,
  CounterSink = 16,
  ThreadMill = 17,
}

// Model ToolType
export type ToolType = {
  id: ToolTypeId
  name: string
}

// Legacy data from tool_materials table
export const TOOL_TYPES: Array<ToolType> = [
  { id: 1, name: 'Flat Endmill' },
  { id: 2, name: 'Radius Endmill' },
  { id: 3, name: 'Ball Endmill' },
  { id: 4, name: 'Chamfer Mill' },
  { id: 5, name: 'Drill' },
  { id: 6, name: 'Face Mill' },
  { id: 7, name: 'Flycutter' },
  { id: 8, name: 'Cutting Tap' },
  { id: 9, name: 'Form Tap' },
  { id: 10, name: 'Lollipop Endmill' },
  { id: 11, name: 'Keyseat Cutter' },
  { id: 12, name: 'Dovetail Cutter' },
  { id: 13, name: 'Reamer' },
  { id: 14, name: 'Boring Bar' },
  { id: 15, name: 'Counter Bore' },
  { id: 16, name: 'Counter Sink' },
  { id: 17, name: 'Thread Mill' },
]

export const TOOL_TYPES_BY_ID = TOOL_TYPES.reduce((acc, tool) => {
  acc[tool.id] = tool
  return acc
}, {} as Record<ToolTypeId, ToolType>)

export function canSidemill(typeId: ToolTypeId) {
  switch (typeId) {
    case ToolTypeId.BallEndmill:
    case ToolTypeId.ChamferMill:
    case ToolTypeId.FaceMill:
    case ToolTypeId.FlatEndmill:
    case ToolTypeId.RadiusEndmill:
    case ToolTypeId.LollipopEndmill:
    case ToolTypeId.KeyseatCutter:
    case ToolTypeId.DovetailCutter:
    case ToolTypeId.BoringBar:
      return true
  }
  return false
}

export const getToolTypeIdFromName = (name: string) => {
  return TOOL_TYPES.filter((toolType) => {
    return toolType.name === name
  })[0]?.id
}

export const getNameFromToolTypeId = (id: ToolTypeId) => {
  return TOOL_TYPES_BY_ID[id]?.name
}
